module.exports = __webpack_public_path__ + "img/2e75021ebd8afdc63f5e2a0fc68d484c.svg";